import { ExamCourseLanguage, ExamCourseType } from '@exam-management/graphql';
import { z } from 'zod';

const NAME_MAX_LENGTH = 255;
const EXAM_CODE_MAX_LENGTH = 20;
const GROUP_NAME_MAX_LENGTH = 256;

export const ExaminationCourseCreationFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกชื่อหลักสูตรทดสอบ' })
    .max(NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(/^[\u0E00-\u0E7Fa-zA-Z0-9_:,()-\s]+$/, {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () เท่านั้น',
    }),
  code: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอก Exam Code' })
    .max(EXAM_CODE_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${EXAM_CODE_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(/^[a-zA-Z0-9_-]+$/, {
      message: 'อนุญาตเฉพาะ a-z, A-Z, 0-9 และเครื่องหมาย - _ เท่านั้น',
    }),
  type: z.enum([ExamCourseType.Main, ExamCourseType.Mock], {
    message: 'กรุณาเลือก Course Type',
  }),
  language: z.enum([ExamCourseLanguage.Th, ExamCourseLanguage.En], {
    message: 'กรุณาเลือก Course Language',
  }),
  group: z
    .object({ label: z.string(), value: z.string(), inputValue: z.string().nullish() })
    .nullish()
    .refine(
      (data) =>
        !data ||
        ((data.inputValue?.length ?? 0) <= GROUP_NAME_MAX_LENGTH &&
          data.value.length <= GROUP_NAME_MAX_LENGTH),
      {
        message: `ชื่อกลุ่มต้องมีความยาวไม่เกิน ${GROUP_NAME_MAX_LENGTH} ตัวอักษร`,
      },
    ),
});

export type ExaminationCourseCreationFormInput = z.infer<
  typeof ExaminationCourseCreationFormSchema
>;
